// extracted by mini-css-extract-plugin
export default {"statistics":"Stats_statistics__wwoZK","statistic":"Stats_statistic__sekMh","value":"Stats_value__shpbj","title":"Stats_title__y7Thf"};